import { render, staticRenderFns } from "./PortalDesignerDashboard.vue?vue&type=template&id=70ca3505&"
import script from "./PortalDesignerDashboard.vue?vue&type=script&lang=js&"
export * from "./PortalDesignerDashboard.vue?vue&type=script&lang=js&"
import style0 from "./PortalDesignerDashboard.vue?vue&type=style&index=0&id=70ca3505&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70ca3505')) {
      api.createRecord('70ca3505', component.options)
    } else {
      api.reload('70ca3505', component.options)
    }
    module.hot.accept("./PortalDesignerDashboard.vue?vue&type=template&id=70ca3505&", function () {
      api.rerender('70ca3505', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/bespoke/pageDesigner/PortalDesignerDashboard.vue"
export default component.exports